export const EN = 'en';
export const VI = 'vi';
export const TH = 'th';
export const ZH_HANT = 'zh-hant';
export const ZH_CN = 'zh-cn';
